module.exports = __webpack_public_path__ + "static/media/rel_relacao_coachee.90e64898.svg";